export const state = {
    monPseudo: null,
    maCouleur: null,
    localStream: null,
    salonActuelID: null,
    destinataireID: null,
    sphereActuelleID: null,
    nomSphereActuelle: "",
    sphereSelectionneeId: null,
    utilisateurs: {},         // Cache des infos agents
    etatsVocauxActuels: {},    // Qui est dans quel vocal
    notifications: {},        // Compteurs de non-lus
    monRoleActuel: 'membre',
    peutGererSalons: false,
    monRoleGlobal: 'user',
    sidebarContexte: 'global',
    membresSphereActuelle: new Set(),
    premierNonVuId: null
};

// Fonction utilitaire pour mettre à jour l'état si besoin
export function updateState(newState) {
    Object.assign(state, newState);
}